module.exports = __webpack_public_path__ + "media/images/alldefault-bedcf393.png";